import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {NotificationBaseApiDto, PaymentArrivedNotificationDataApiDto} from "../../../api/model/rest";
import {option, Option} from "ts-option";

/**
 * Payment arrived notification class.
 */
export default class PaymentArrivedNotification extends NotificationBase {
	/**
	 * @param {string} id notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read flag if notification is marked as read.
	 * @param {string} type in this case always 'PAYMENT_ARRIVED'.
	 * @param {PaymentArrivedNotificationData} data payment arrived notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: PaymentArrivedNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): PaymentArrivedNotification {
		return new PaymentArrivedNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			PaymentArrivedNotificationData.fromJson(json.data as PaymentArrivedNotificationDataApiDto));
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new PaymentArrivedNotification(id, dateTime, read, type, data);
	}
}

/**
 * Payment arrived notification class data.
 */
export class PaymentArrivedNotificationData {
	constructor(readonly transactionId: string, readonly invoiceId: Option<string>, readonly jobRefNumber: Option<string>) {}

	static fromJson(json: PaymentArrivedNotificationDataApiDto): PaymentArrivedNotificationData {
		return new PaymentArrivedNotificationData(json.transactionId, option(json.invoiceId), option(json.jobRefNumber))
	}
}
